<template>
  <div class="full-width">
    <script type="application/ld+json">
      {
        "@context": "http://schema.org",
        "@graph": [
          {
            "@type": "Article",
            "url": "https://www.teddi.co/request-new-password/",
            "headline": "Mot de passe oublié ? ← Teddi",
            "description": "Réinitialisez votre mot de passe Teddi.",
            "datePublished": "2020-06-14T17:47:50.000Z",
            "dateModified": "2020-06-15T09:20:51.000Z",
            "mainEntityOfPage": {
              "@type": "WebPage",
              "@id": "https://www.teddi.co/request-new-password/"
            },
            "publisher": {
              "@type": "Organization",
              "@id": "https://www.teddi.co/",
              "name": "Teddi",
              "logo": {
                "@type": "ImageObject",
                "url": "https://www.teddi.co/assets/socials/fb-profile.png",
                "width": 1000,
                "height": 1000
              }
            },
            "author": {
              "@type": "Person",
              "name": "Thomas"
            }
          }
        ]
      }
    </script>
    <b-row class="center">
      <b-col md="3" class="mx-auto">
        <b-form @submit.prevent="forgotPasswordRequest">
          <h2 class="mb-4">Mot de passe oublié ?</h2>

          <b-form-input
            v-model="email"
            type="email"
            required
            lazy
            placeholder="E-mail"
            class="mb-4"
          ></b-form-input>

          <b-button class="btn-primary text-uppercase px-4 py-2 btn-block" type="submit"
            >Réinitialiser</b-button
          >
        </b-form>
        <div class="d-flex flex-column links mt-3">
          <router-link :to="{ name: 'login' }">
            Se connnecter
          </router-link>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  computed: {
    ...mapState(["loading"]),
    email: {
      get() {
        return this.$store.state.userData.email;
      },
      set(value) {
        this.$store.commit("SET_EMAIL", value);
      },
    },
  },
  methods: {
    ...mapActions(["forgotPasswordRequest"]),
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/forms.scss";
@import "@/styles/buttons.scss";

a:link {
  color: $primary;
}
.form-control {
  padding: 13px !important;
}
</style>
